module.exports = __webpack_public_path__ + "img/nowater.147b7a18.svg";